<!--
File: product-grid.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Thursday, 7th November 2024 5:33:11 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div class="grid justify-content-center max-w-full p-0 ml-0" pDroppable (onDrop)="onDrop($event)">
  <div class="col-6" *ngFor="let item of items">
    <app-product-grid-item [item]="item"> </app-product-grid-item>
  </div>
</div>
